/*
 * @Author: Vanny
 * @Date: 2019-05-16 13:45:29
 * @LastEditors: Vanny
 * @LastEditTime: 2019-12-05 21:40:34
 * @Description:
 */
import 'moment/locale/zh-cn';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/pt';
import 'moment/locale/tr';
import '@babel/polyfill';
import React from 'react';
import ReactDom from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { createHashHistory } from 'history';
import { Provider } from 'react-redux';
import { notification, Spin, Icon } from 'antd';

import { $t } from './tools';
import registerServiceWorker from './registerServiceWorker';
import axiosConfig from './config/axios';
import version from './utils/version';
import { getStore, runSaga } from './stores';
import App from './App';
import './index.less';

version();

const history = createHashHistory();
const { store, persistor } = getStore(history);
runSaga();
axiosConfig(store,persistor);
const render = (App) => {
  ReactDom.render(
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<Spin indicator={<Icon type="loading" />} />}>
        <App history={history} />
      </PersistGate>
    </Provider>,
    document.getElementById('root')
  );
};

render(App);

registerServiceWorker({
  onSuccess(registration) {
    registration.update();
  },
  onUpdate() {
    notification.success({
      message: (
        <>
          <span>
            {$t('new_version', 'Global')}，
            <a onClick={() => window.location.reload()}>{$t('click_here', 'Global')}</a>{' '}
            {$t('reload_new', 'Global')}
          </span>
        </>
      ),
    });
  },
});
